import { useRouter } from 'next/compat/router';
import { type ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

// Compatibility hook to provide a consistent API for accessing query parameters
// across both the `pages/` and `app/` directories in Next.js.
export const useQuery = () => {
  const router = useRouter();
  const maybeSearchParams = useSearchParams();

  const [searchParams, setSearchParams] = useState<ReadonlyURLSearchParams | null>(null);

  useEffect(() => {
    if (router && !router.isReady) {
      return;
    }

    setSearchParams(maybeSearchParams);
  }, [router, maybeSearchParams]);

  return { isReady: router?.isReady ?? true, searchParams };
};
